import { AppTheme } from "./../../theme/Theme";
export type ColorType =
	| "black"
	| "white"
	| "grayText"
	| "grayTextDark"
	| "grayTextLight"
	| "dividerGray"
	| "brandColorLight"
	| "actionBlue"
	| "lightGray"
	| "lightBlue"
	| "dark"
	| "primary"
	| "secondary"
	| "green"
	| "danger"
	| "buttonGray"
	| "buttonTextGray"
	| "transparent"
	| "lightGray2"
	| "orange"
	| "blueLight"
	| undefined;

export const getFontColor = (color: ColorType, theme: AppTheme) => {
	switch (color) {
		case "black":
			return theme.colors.COLOR_BLACK;
		case "white":
			return theme.colors.COLOR_WHITE;
		case "grayText":
			return theme.colors.COLOR_GRAY_TEXT;
		case "grayTextDark":
			return theme.colors.COLOR_GRAY_TEXT_DARK;
		case "grayTextLight":
			return theme.colors.COLOR_GRAY_TEXT_LIGHT;
		case "dividerGray":
			return theme.colors.COLOR_DIVIDER_GRAY;
		case "brandColorLight":
			return theme.colors.COLOR_BRAND_COLOR_LIGHT;
		case "actionBlue":
			return theme.colors.COLOR_ACTION_BLUE;
		case "lightGray":
			return theme.colors.COLOR_LIGHT_GRAY;
		case "lightBlue":
			return theme.colors.COLOR_LIGHT_BLUE;
		case "dark":
			return theme.colors.COLOR_DARK;
		case "primary":
			return theme.colors.COLOR_ACNE_PRIMARY;
		case "secondary":
			return theme.colors.COLOR_ACNE_SECONDARY;
		case "green":
			return theme.colors.COLOR_ORIGO_GREEN;
		case "danger":
			return theme.colors.COLOR_DANGER;
		case "buttonGray":
			return theme.colors.BUTTON_GRAY;
		case "buttonTextGray":
			return theme.colors.BUTTON_TEXT_GRAY;
		case "transparent":
			return theme.colors.COLOR_TRANSPARENT;
		case "lightGray2":
			return theme.colors.COLOR_LIGHT_GRAY2;
		case "orange":
			return theme.colors.COLOR_ORANGE;
		case "blueLight":
			return theme.colors.COLOR_BLUE_LIGHT;
		default:
			return color;
	}
};
